import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .daffney-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: var(--between-row-padding-lg) 0;
    }

    .image-wrapper {
      cursor: pointer;
    }

    .image-wrapper-full {
      grid-column: 1 / 3;
    }

    .image-driver {
      height: calc(80rem / var(--default-rem-px-count));
      background-color: rgb(240, 240, 240);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 calc(20rem / var(--default-rem-px-count));
      margin-top: calc(-4rem / var(--default-rem-px-count));
    }

    .right-arrow {
      padding-left: calc(10rem / var(--default-rem-px-count));
    }

    .image > img {
      width: 100%;
    }

    @media (min-width: 600px) {
      .daffney-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .images {
        grid-column: 4 / 12;
        grid-row: 2;
        display: inline-grid;
        grid-template-columns: repeat(2, 2fr);
        gap: var(--between-row-padding-lg) var(--between-column-padding-lg);
      }
    }
  `,
];
